module.exports = __webpack_public_path__ + "media/images/icons/waypoint-ba1231283d208392a6e87eca266f1a64.png";